import type { FaireProductEntity } from "../../entity_types/product";

export const p_gds2rb5gux: FaireProductEntity = {
  token: "p_gds2rb5gux",
  type: "product",
  name: "Foodie Gourmet - Belgium - Milk Chocolate Melting Wafers (35% Cacao) - 8.8 oz",
  brandToken: "b_bzxg32q5dk",
  brandName: "Alta Gama Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/ba3a01cba3838e625081e75177d6324cd34d618484ae9bc6fa744378a0ee1181.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4ed943baeb6d3d6a608c480385f7e77287a32e515f70f8928fed911463a1e765.png",
    "https://cdn.faire.com/fastly/97f0f52c68f191413f2e6309d43c471aae97d22b7af1b84ea889b06441ab4767.png",
    "https://cdn.faire.com/fastly/cdc8bb2a861895d33a34f8341a84f7ff512f0846ebea9209f2dbaca896b72a1c.jpeg",
  ],
  priceDollars: 7.21,
  description:
    "Bring a creamy and luxurious touch to your baking and desserts with Foodie Gourmet Milk Chocolate Melting Wafers. Crafted with 35% premium cacao, these wafers are expertly made in Belgium to deliver a velvety texture and rich, indulgent flavor. Perfectly designed to melt with ease, they bring a luscious chocolatey essence to a variety of culinary creations.\n\nKey Features:\n\nPremium Cacao Content: Made with 35% cacao for a smooth and creamy milk chocolate flavor.\nBelgian Craftsmanship: Expertly crafted in Belgium for a superior taste and texture.\nPerfect for Melting: Designed to melt effortlessly, ensuring a silky, professional finish for your recipes.\nVersatile Use: Ideal for ganache, dipping fruits, drizzling over desserts, or adding to baked goods.\nIdeal Uses:\n\nGanache & Sauces: Create rich and silky chocolate ganache or dessert sauces.\nBaking: Incorporate into cakes, cookies, or brownies for a creamy milk chocolate flavor.\nDipping & Drizzling: Use for dipping fruits, pretzels, or mar",
  tags: [],
  msrpDollars: 14.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:35.108Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
